export default __webpack_public_path__ + "static/media/N-01.26e04982.png";